
import { Route, Routes, useLocation } from "react-router-dom";

// Repeated Components
import Footer from './general/Footer';
import Navbar from './general/Navbar';


import Home from './home/Home';


// Text Gizmo components import
import { ImageProvider } from "./general/ImageProvider";
import Insights from "./general/Insights";
import PageNotFound from "./general/PageNotFound";
import ImgGizmo from './img-gizmo/ImgGizmo';
import SocialAutomation from './social-automation/SocialAutomation';
import ConvertCase from './text-gizmo/ConvertCase';
import HTMLformatter from "./text-gizmo/HTMLformatter";
import ReplaceText from './text-gizmo/ReplaceText';
import TextGizmo from './text-gizmo/TextGizmo';



// import pageNotFound from '../img/giphy.gif';
function InnerApp() {
  const location = useLocation();

  return (
    <>
      <ImageProvider>
        {location.pathname !== "/" && <Navbar navtitle="Home" texttitle="Text & Code Gizmo" imgtitle="Image Gizmo" insighttitle="Insight" contacttitle="Contact Us" />}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/text-gizmo" element={<TextGizmo />} />
          <Route path="/image-gizmo" element={<ImgGizmo />} />
          <Route path="text-gizmo/convert-case" element={<ConvertCase />} />
          <Route path="text-gizmo/replace-text" element={<ReplaceText />} />
          <Route path="code-gizmo/html-beautify" element={<HTMLformatter />} />
          <Route path="/social-automation" element={<SocialAutomation />} />


          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </ImageProvider>
      {location.pathname !== "/" && <Footer quicklink="Overview" quicklink1="Insights" quicklink2="Contact Us" service="Text & Code Gizmo" service1="Image Gizmo" service2="PDF Gizmo" service3=" " />}
    </>
  );
}

export default InnerApp;
